import React, { useEffect, useState } from "react";
import { Link,useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import logo from '../Images/logo.png'
import whitelogo from '../Images/white-logo.png'
import { aboutLinks, bentoniteDropdown, industrialMinerals } from "../Data";
import { FaYoutube, FaFacebookF, FaLinkedinIn, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

const BreadCrumb=({ title, bgImage, youtubeLink = null })=>{
  const [scrolled, setScrolled] = useState(false);
    const [hovered, setHovered] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
    const navigate = useNavigate();
  
   useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [menuOpen]);
  
    // Inside your Hero component
useEffect(() => {
  const handleScroll = () => {
    const y = window.scrollY;
    // Lower threshold ensures the smooth CSS transition starts as soon as user begins scrolling down
    setScrolled(y > 10);
  };

  window.addEventListener("scroll", handleScroll, { passive: true });
  return () => window.removeEventListener("scroll", handleScroll);
}, []);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };
  
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
    const navContainer = {
      hidden: { opacity: 0, y: -30 },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.8,
          ease: "easeOut",
          staggerChildren: 0.08
        }
      }
    };
  
    const navItem = {
      hidden: { opacity: 0, y: -10 },
      visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.5, ease: "easeOut" }
      }
    };

    return(
        <>
      <motion.header
        variants={navContainer}
        initial="hidden"
        animate="visible"
        className={`navbar ${scrolled ? "scrolled" : ""} ${
          hovered ? "hovered" : ""
        }`}
        onMouseEnter={() => !isMobile && setHovered(true)}
onMouseLeave={() => !isMobile && setHovered(false)}
      >
        {/* LOGO */}
        <motion.div
          className="logo-row"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
        <img   src={isMobile ? logo : (scrolled || hovered ? logo : whitelogo)} alt="Iris Impulse India Pvt. Ltd. Logo" className="logo" />

  {/* HAMBURGER */}
  <div
    className={`hamburger ${menuOpen ? "active" : ""}`}
    onClick={() => setMenuOpen(!menuOpen)}
  >
    <span></span>
    <span></span>
    <span></span>
  </div>
        </motion.div>

        {/* NAV LINKS */}
        <nav className="nav-row">
          <ul>
         <a href="/"><motion.li variants={navItem}>HOME</motion.li></a>
            <span className="diamond"></span>

           <motion.li variants={navItem} className="dropdown">
                         <a href="/about-us"><span className="nav-item">
                           ABOUT US
                           <span className="chevron"></span>
                         </span></a>
           
                         <ul className="dropdown-menu">
                           {aboutLinks.map((item, index) => (
                            <Link to={item.url}><li key={index}>{item.title}</li></Link> 
                           ))}
                         </ul>
                       </motion.li>
            <span className="diamond"></span>

            {/* BENTONITE */}
            <motion.li variants={navItem} className="dropdown">
              <a href="/bentonite-minerals"><span className="nav-item">
                BENTONITE MINERALS
                <span className="chevron"></span>
              </span></a>

              <ul className="dropdown-menu">
                {bentoniteDropdown.map((item, index) => (
                <Link to={`/bentonite-minerals/${item.url}`}><li key={index}
                  >{item.title}</li></Link>  
                ))}
              </ul>
            </motion.li>

            <span className="diamond"></span>

            {/* INDUSTRIAL */}
            <motion.li variants={navItem} className="dropdown">
                <a href="/industrial-minerals"><span className="nav-item">
                INDUSTRIAL MINERALS
                <span className="chevron"></span>
              </span></a>
 <ul className="dropdown-menu">
                {industrialMinerals.map((item, index) => (
                  <Link to={`/industrial-minerals/${item.url}`}><li key={index}>{item.title}</li></Link> 
                ))}
              </ul>
            </motion.li>

            <span className="diamond"></span>

            <a href="/blogs"><motion.li variants={navItem}>BLOGS</motion.li></a>
            <span className="diamond"></span>

            <a href="/contact-us"><motion.li variants={navItem}>CONTACT US</motion.li></a>
          </ul>
        </nav>
      </motion.header>

      {/* SIDEBAR */}
<div className={`mobile-sidebar ${menuOpen ? "active" : ""}`}>
  
  {/* TOP LOGO */}
  <div className="sidebar-header">
    <img src={logo} alt="Iris Impulse India Pvt. Ltd. Logo" />
  </div>

  <ul>
    <a href="/"><li onClick={() => setMenuOpen(false)}>HOME</li></a>

    <li className="mobile-dropdown">
      <div className="mobile-dropdown-head">
        <span onClick={() => navigate("/about-us")}>
          ABOUT US
        </span>

        <span
          className={`chevron ${openDropdown === "about" ? "open" : ""}`}
          onClick={() =>
            setOpenDropdown(openDropdown === "about" ? null : "about")
          }
        ></span>
      </div>

      <div className={`mobile-submenu ${openDropdown === "about" ? "open" : ""}`}>
        {aboutLinks.map((item, index) => (
          <Link key={index} to={item.url}>
            <div>{item.title}</div>
          </Link>
        ))}
      </div>
    </li>

    {/* BENTONITE */}
    <li className="mobile-dropdown">
      <div className="mobile-dropdown-head">
        <span onClick={() => navigate("/bentonite-minerals")}>
          BENTONITE MINERALS
        </span>

        <span
          className={`chevron ${openDropdown === "bentonite" ? "open" : ""}`}
          onClick={() =>
            setOpenDropdown(openDropdown === "bentonite" ? null : "bentonite")
          }
        ></span>
      </div>

      <div className={`mobile-submenu ${openDropdown === "bentonite" ? "open" : ""}`}>
        {bentoniteDropdown.map((item, index) => (
          <Link key={index} to={`/bentonite-minerals/${item.url}`}>
            <div>{item.title}</div>
          </Link>
        ))}
      </div>
    </li>

    {/* INDUSTRIAL */}
    <li className="mobile-dropdown">
      <div className="mobile-dropdown-head">
        <span onClick={() => navigate("/industrial-minerals")}>
          INDUSTRIAL MINERALS
        </span>

        <span
          className={`chevron ${openDropdown === "industrial" ? "open" : ""}`}
          onClick={() =>
            setOpenDropdown(openDropdown === "industrial" ? null : "industrial")
          }
        ></span>
      </div>

      <div className={`mobile-submenu ${openDropdown === "industrial" ? "open" : ""}`}>
        {industrialMinerals.map((item, index) => (
          <Link key={index} to={`/industrial-minerals/${item.url}`}>
            <div>{item.title}</div>
          </Link>
        ))}
      </div>
    </li>

    <a href="/blogs">
      <li onClick={() => setMenuOpen(false)}>BLOGS</li>
    </a>

    <a href="/contact-us">
      <li onClick={() => setMenuOpen(false)}>CONTACT US</li>
    </a>
  </ul>

  {/* SIDEBAR FOOTER */}
  <div className="mobile-sidebar-footer">

    {/* SOCIAL ICONS */}
    <div className="sidebar-socials">

      <a
        href="https://www.youtube.com/@IrisImpulseIndia"
        target="_blank"
        rel="noreferrer"
      >
        <FaYoutube />
      </a>

      <a
        href="https://www.facebook.com/Irisimpulsebentonite"
        target="_blank"
        rel="noreferrer"
      >
        <FaFacebookF />
      </a>

      <a
        href="https://www.linkedin.com/company/iris-impulse-india-private-limited/"
        target="_blank"
        rel="noreferrer"
      >
        <FaLinkedinIn />
      </a>

    </div>

    {/* EMAIL */}
    <a
      href="mailto:rajan@irisimpulse.com"
      className="sidebar-contact"
    >
      <FaEnvelope />
      <span>rajan@irisimpulse.com</span>
    </a>

    {/* PHONE */}
    <a
      href="tel:+919638482211"
      className="sidebar-contact"
    >
      <FaPhoneAlt />
      <span>+91 96384 82211</span>
    </a>

  </div>

</div>

{/* OVERLAY */}
<div
  className={`sidebar-overlay ${menuOpen ? "active" : ""}`}
  onClick={() => setMenuOpen(false)}
/>
        <section
      className="breadcrumb"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="breadcrumb-overlay" />

      <div className="breadcrumb-content container">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          {title}
        </motion.h1>
      </div>

    {youtubeLink && (
  <motion.a
    href={youtubeLink}
    target="_blank"
    rel="noopener noreferrer"
    className="breadcrumb-youtube-btn"
    initial={{ opacity: 0, x: -20 }}
    animate={{
      opacity: 1,
      x: 0,
      scale: [1, 1.2, 1, 1.2, 1],
    }}
    transition={{
      opacity: { duration: 0.5 },
      x: { duration: 0.5 },
      scale: {
        duration: 0.6,
        repeat: Infinity,
        repeatDelay: 1.5,
        ease: "easeInOut",
      },
    }}
    whileHover={{
      scale: 1.15,
    }}
    whileTap={{
      scale: 0.95,
    }}
  >
    <FaYoutube />
  </motion.a>
)}
    </section>
        </>
    )
}
export default BreadCrumb;